/* unplugin-vue-components disabled */import script from "./TravelDetails2.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelDetails2.vue?vue&type=script&setup=true&lang=js"

import "./TravelDetails2.vue?vue&type=style&index=0&id=2d15acd7&scoped=true&lang=css"
import "./TravelDetails2.vue?vue&type=style&index=1&id=2d15acd7&lang=scss"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d15acd7"]])

export default __exports__